import React from 'react';
import Title from '../components/Title';
import { assets } from '../assets/assets';
import Newsletter from '../components/Newsletter';

const contact = () => {
  return (
    <div>
      <div className="text-center text-2xl pt-32 border-t">
        <Title text1={'CONTACT'} text2={' US'} />
      </div>
      <div className="my-10 flex flex-col justify-center md:flex-row gap-10 mb-28">
        <img className="w-full md:max-w-[480px]" src={assets.hero_img2} />
        <div className="flex flex-col justify-center items-start gap-6">
          <p className="font-semibold text-xl">Our Store</p>
          <p className="text-gray-500">Forever Store,Bangalore</p>
          <p className="text-gray-500">
            Tel: (91) 9999637257
            <br /> Email: chaisha@forever.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default contact;
